import {Text} from '@/components-v2/atoms/Text/Text'

/**
 * @param {{keyName: string, val: import('react').ReactNode, className?: string}} props
 */
export const LabelValue = ({keyName, val, className = ''}) => {
  const id = keyName?.toLowerCase()?.replaceAll(' ', '_') ?? ''

  return (
    <div className={`w-full overflow-hidden pt-5 ${className}`}>
      <div>
        <Text id={`${id}_label`} size="xsmall" variant="regular" textColorClass="text-gray-300">
          {keyName}
        </Text>
      </div>
      <div>
        <Text id={`${id}_value`} size="small" variant="bold" textColorClass="text-white">
          {val ?? '-'}
        </Text>
      </div>
    </div>
  )
}
